import { QueryClient } from "@tanstack/react-query";

import { isStaffListKey, loadStaffNamesFrom } from "@/lib/staff-name-display";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: false,
    },
  },
});

// formatStaffName names staff from the cached staff lists; keep its copy in
// step whenever one of those lists changes.
queryClient.getQueryCache().subscribe(({ query }) => {
  if (isStaffListKey(query.queryKey)) loadStaffNamesFrom(queryClient);
});
